// ----------------------------------------------------------------------- imports internos
import { ubicacion } from "../../shared/ubicacion";

/* «Última ubicación registrada», la misma en todas las pantallas.
 *
 * Está acá y no adentro de la tabla de furgones porque la misma respuesta se
 * muestra en la ficha del tractor, y el día que las dos copias difieran el hub
 * diría dos cosas del mismo camión. Es la misma razón por la que `ChipUsuario`
 * salió de adentro de Viajes.
 *
 * DOS COSAS QUE NO SE PUEDEN SEPARAR:
 *
 *   · EL LUGAR VA SIEMPRE CON LA FECHA. «Río Grande» solo se lee como «está
 *     ahí ahora»; con la fecha al lado se lee como lo que es, que es dónde se
 *     lo vio por última vez.
 *   · Y EL `title` DICE DE DÓNDE SALIÓ. Portería y el movimiento de unidades no
 *     pesan lo mismo —una es de hoy, el otro viene atrasado— y en una celda se
 *     ven idénticos.
 *
 * Sin registro dibuja un guion y no una celda en blanco: vacía se lee como que
 * la pantalla no terminó de cargar.
 */
const Ubicacion = ({ fila }) => {
  const u = ubicacion(fila);
  return (
    <span className={"ubic" + (u.vacio ? " ubic--vacia" : "")} title={u.detalle}>
      <span className="ubic-lugar">{u.texto}</span>
      {u.fecha && <span className="ubic-fecha">{u.fecha}</span>}
    </span>
  );
};

export default Ubicacion;
